import styled from 'styled-components'

export const ColumnLabel = styled.div`
	display: block;
	font-family: ${({ theme }) => theme.font.family.base};
	position: relative;
	min-width: 100px;
	margin-bottom: 20px;
`
